// extracted by mini-css-extract-plugin
export default {"labelForm":"ContactForm_labelForm__weTgn","customFormControl":"ContactForm_customFormControl__fAG63"};